const defaultState = () => {
  return {
    lessons: [],
    creatingLesson: false,
  };
};

const defaultParams = {
  variant: 'itemdeliverystrategyweightedrandom',
};

const getters = {
  lessons: state => state.lessons,
};

const mutations = {
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  addLesson(state, lesson) {
    state.lessons.push(lesson);
  },
  setCreatingLesson(state, value) {
    state.creatingLesson = value;
  },
  resetLessons(state) {
    state.lessons = [];
    state.creatingLesson = false;
  },
};

const actions = {
  fetchLessons({ commit, rootGetters }, params) {
    return rootGetters['session/ajax'].get('/lessons', { params }).then(response => {
      commit('setLessons', response.data.records || []);
      return response;
    });
  },

  createLesson({ commit, state, rootGetters }, params = defaultParams) {
    if (state.creatingLesson) {
      return Promise.resolve();
    }
    commit('setCreatingLesson', true);
    return rootGetters['session/ajax']
      .post('/lessons', params)
      .then(response => {
        commit('addLesson', response.data.records[0]);
        return response;
      })
      .finally(() => {
        commit('setCreatingLesson', false);
      });
  },

  resetLessons({ commit, rootGetters }) {
    return rootGetters['session/ajax'].post('/lessons/reset').then(response => {
      commit('resetLessons');
      return response;
    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
